import { ReactNode } from 'react'
import { GeoShape } from './Types'
import { SvgExportDef, toDomPrecision } from '@tldraw/tldraw'

type ShadowResult = {
  id: string
  svgDimensions: { width: number; height: number }
  svgTranslate: { x: number; y: number }
  pathTranslate: { x: number; y: number }
  defs: ReactNode
  svgExportDef: SvgExportDef
}

export const getShadow = (shape: GeoShape): ShadowResult => {
  const { shadow, strokeWidth, w, h } = shape.props
  const id = `${shape.id}_shadow`

  if (!shadow) {
    return {
      id,
      svgDimensions: { width: 0, height: 0 },
      svgTranslate: { x: 0, y: 0 },
      pathTranslate: { x: 0, y: 0 },
      defs: null,
      svgExportDef: {
        key: id,
        getElement: () => [],
      },
    }
  }

  const shadowWidth = Math.abs(shadow.x) + shadow.blur * 2 + strokeWidth
  const shadowHeight = Math.abs(shadow.y) + shadow.blur * 2 + strokeWidth
  const filterWidth = toDomPrecision(w + Math.abs(shadow.x) + shadow.blur * 2 + strokeWidth)
  const filterHeight = toDomPrecision(h + Math.abs(shadow.y) + shadow.blur * 2 + strokeWidth)
  const filterX = -(strokeWidth / 2 + shadow.blur)
  const filterY = -(strokeWidth / 2 + shadow.blur)

  return {
    id,
    svgDimensions: {
      width: shadowWidth,
      height: shadowHeight,
    },
    svgTranslate: {
      x: Math.min(0, shadow.x),
      y: Math.min(0, shadow.y),
    },
    pathTranslate: {
      x: Math.max(0, -shadow.x),
      y: Math.max(0, -shadow.y),
    },
    defs: (
      <filter
        id={id}
        x={filterX}
        y={filterY}
        width={filterWidth}
        height={filterHeight}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feDropShadow
          dx={shadow.x}
          dy={shadow.y}
          stdDeviation={shadow.blur / 2}
          floodOpacity={shadow.opacity}
          floodColor={shadow.color}
        />
      </filter>
    ),
    svgExportDef: {
      key: id,
      getElement: () => {
        const divEl = document.createElement('div')
        divEl.innerHTML = `
          <svg>
            <defs>
              <filter
                id="${id}"
                x="${filterX - Math.max(0, -shadow.x)}"
                y="${filterY - Math.max(0, -shadow.y)}"
                width="${filterWidth}"
                height="${filterHeight}"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feDropShadow
                  dx="${shadow.x}"
                  dy="${shadow.y}"
                  stdDeviation="${shadow.blur / 2}"
                  flood-opacity="${shadow.opacity}"
                  flood-color="${shadow.color}"
                />
              </filter>
            </defs>
          </svg>
        `
        return Array.from(divEl.querySelectorAll('defs > *'))
      },
    },
  }
}
